<section class="section-color" id="blog">
    <div class="container" style="padding-top: 100px; padding-bottom: 100px;">
        <div class="row fade-bottom" style="position: relative;
        animation-duration: 1000ms;
        transition-timing-function: ease;
        transition-delay: 0ms;">
            <div class="title" style="margin-bottom: 0;">
                <h2 class="text-primary" style="margin: 0;">Software solutions to scale your business</h2>
                <p class="text-secondary">Our articles</p>
            </div>
        </div>
        <div class="grid-box3 fade-bottom" style="margin-top: 60px; position: relative;
        animation-duration: 1000ms;
        transition-timing-function: ease;
        transition-delay: 0ms;">
            <div *ngFor="let article of articles" class="grid-item">
                <a [href]="'/blog/article/' + article.slug.S" [routerLink]="['/blog/article', article.slug.S]">
                    <div class="cnt-box cnt-box-info boxed">
                        <div class="img-box"><img [src]="article.thumbnail.S" width="800" height="501" alt=""></div>
                        <div class="caption">
                            <h2 class="text-primary">{{article.title.S}}</h2>
                            <p>
                                {{article.description.S}}
                            </p>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</section>
